export const dokterMenu = {
	top: [
		{
			id: "admin-dashboard",
			title: "Dashboard",
			icon: "icon-ico-dashboard",
			path: "/",
			submenu: [],
		},
		{
			id: "admin-post",
			title: "Post",
			icon: "icon-ico-pencil",
			path: "/doctor/post/list",
			submenu: [],
		},
		{
			id: "doctor-appointment",
			title: "Appointment",
			icon: "icon-ico-appointment",
			path: "/doctor/appointment/list",
			submenu: [],
		},
		{
			id: "doctor-price",
			title: "Set Harga",
			icon: "icon-ico-card",
			path: "/doctor/price/list",
			submenu: [],
		},
		{
			id: "absensi-staff",
			title: "Absensi Staff",
			icon: "icon-ico-dashboard",
			path: "/absensi-staff",
			submenu: [],
		},
	],
	bottom: [
		{
			id: "dokter-schedule-list",
			title: "Schedule",
			icon: "icon-ico-calendar",
			path: "/doctor/schedule/list",
			submenu: [],
		},
	],
};
